(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["metal-calculator"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.metal-calculator-section');
  if (!section) return;
  
  var SUPABASE_URL = 'https://yfnbziyirorwokaagzsb.supabase.co';
  var SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlmbmJ6aXlpcm9yd29rYWFnenNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUzNTE1MzcsImV4cCI6MjA4MDkyNzUzN30.fUpUSlKfwrBWUvcsmLG2ETv05kGelIB_p19UTjvogp0';
  
  var metalTypeEl = section.querySelector('[data-metal-type]');
  var metalType = metalTypeEl ? metalTypeEl.dataset.metalType : 'gold';
  var weightInput = section.querySelector('[data-calculator-input="weight"]');
  var puritySelect = section.querySelector('[data-calculator-input="purity"]');
  var calculateBtn = section.querySelector('[data-calculator-button]');
  var resultOutput = section.querySelector('[data-calculator-output]');
  var currencyToggle = section.querySelector('[data-toggle-type="calc-currency"]');
  var currentCurrency = 'EUR';
  
  var historyTables = { gold: 'gold_prices_history', silver: 'silver_prices_history', platinum: 'platinum_prices_history', palladium: 'palladium_prices_history' };
  var metalSymbols = { gold: 'XAU', silver: 'XAG', platinum: 'XPT', palladium: 'XPD' };
  
  function formatVal(v, isPos) {
    var sign = isPos ? '+' : '';
    return sign + v.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' EUR';
  }
  
  function formatPct(v, isPos) {
    var sign = isPos ? '+' : '';
    return sign + v.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' %';
  }
  
  function getDate(days) {
    var d = new Date();
    d.setDate(d.getDate() - days);
    return d.toISOString().split('T')[0];
  }
  
  function getYearStart() {
    return new Date().getFullYear() + '-01-01';
  }
  
  function loadHistory() {
    var card = section.querySelector('[data-history-card]');
    if (!card) return;
    var table = historyTables[metalType];
    var symbol = metalSymbols[metalType];
    if (!table || !symbol) {
      console.warn('History: Invalid metal type', metalType);
      return;
    }
    
    console.log('History: Loading for', metalType, symbol, table);
    
    var headers = { 'apikey': SUPABASE_KEY, 'Authorization': 'Bearer ' + SUPABASE_KEY };
    
    fetch(SUPABASE_URL + '/rest/v1/metal_prices_current?select=price_eur&metal_symbol=eq.' + symbol, { headers: headers })
      .then(function(res) {
        if (!res.ok) throw new Error('Current price fetch failed: ' + res.status);
        return res.json();
      })
      .then(function(currData) {
        var currPrice = currData && currData[0] ? parseFloat(currData[0].price_eur) : 0;
        if (currPrice === 0) {
          console.warn('History: No current price found for', symbol);
          return;
        }
        console.log('History: Current price for', symbol, '=', currPrice);
        
        var periods = [
          { key: 'ytd', date: getYearStart() },
          { key: '30d', date: getDate(30) },
          { key: '6m', date: getDate(180) },
          { key: '1y', date: getDate(365) },
          { key: '5y', date: getDate(1825) },
          { key: '10y', date: getDate(3650) }
        ];
        
        periods.forEach(function(p) {
          var valEl = card.querySelector('[data-history-value="' + p.key + '"]');
          var pctEl = card.querySelector('[data-history-percent="' + p.key + '"]');
          
          fetch(SUPABASE_URL + '/rest/v1/' + table + '?select=close_eur,price_date&price_date=gte.' + p.date + '&order=price_date.asc&limit=1', { headers: headers })
            .then(function(res) {
              if (!res.ok) throw new Error('Fetch failed: ' + res.status);
              return res.json();
            })
            .then(function(data) {
              if (data && data.length > 0 && data[0].close_eur) {
                var oldPrice = parseFloat(data[0].close_eur);
                var diff = currPrice - oldPrice;
                var pct = ((currPrice - oldPrice) / oldPrice) * 100;
                var isPos = diff >= 0;
                console.log('History:', p.key, '- Old:', oldPrice, 'Diff:', diff.toFixed(2), 'Pct:', pct.toFixed(2));
                if (valEl) {
                  valEl.textContent = formatVal(diff, isPos);
                  valEl.classList.toggle('negative', !isPos);
                }
                if (pctEl) {
                  pctEl.textContent = formatPct(pct, isPos);
                  pctEl.classList.toggle('negative', !isPos);
                }
              } else {
                console.warn('History: No data for', p.key, 'from', p.date);
                if (valEl) valEl.textContent = 'k.A.';
                if (pctEl) pctEl.textContent = 'k.A.';
              }
              var row = card.querySelector('.metal-calculator-section__history-row[data-period="' + p.key + '"]');
              if (row) row.classList.add('is-loaded');
            })
            .catch(function(err) {
              console.error('History: Error for period', p.key, err);
              if (valEl) valEl.textContent = 'k.A.';
              if (pctEl) pctEl.textContent = 'k.A.';
              var row = card.querySelector('.metal-calculator-section__history-row[data-period="' + p.key + '"]');
              if (row) row.classList.add('is-loaded');
            });
        });
      })
      .catch(function(e) {
        console.error('History load error:', e);
      });
  }
  
  if (currencyToggle) {
    currencyToggle.addEventListener('click', function(e) {
      var btn = e.target.closest('.metal-calculator-section__toggle');
      if (!btn) return;
      currencyToggle.querySelectorAll('.metal-calculator-section__toggle').forEach(function(b) {
        b.classList.remove('metal-calculator-section__toggle--active');
      });
      btn.classList.add('metal-calculator-section__toggle--active');
      currentCurrency = btn.dataset.value;
    });
  }
  
  function calculate() {
    var weight = weightInput ? parseFloat(weightInput.value) : 0;
    var purity = puritySelect ? parseFloat(puritySelect.value) : 0;
    if (weight <= 0 || purity <= 0) {
      if (resultOutput) resultOutput.innerHTML = '<span class="result-placeholder">Bitte alle Felder ausfuellen</span>';
      return;
    }
    if (!window.metalPricesData || !window.metalPricesData[metalType]) {
      if (resultOutput) resultOutput.innerHTML = '<span class="result-placeholder">Preisdaten werden geladen...</span>';
      return;
    }
    var data = window.metalPricesData[metalType];
    var pricePerGram = currentCurrency === 'EUR' ? data.perGram : data.perGramUsd;
    var value = weight * pricePerGram * (purity / 1000);
    var sym = currentCurrency === 'EUR' ? 'EUR' : 'USD';
    if (resultOutput) {
      resultOutput.textContent = value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ' ' + sym;
    }
  }
  
  if (calculateBtn) {
    calculateBtn.addEventListener('click', calculate);
  }
  if (weightInput) {
    weightInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') calculate();
    });
  }
  
  loadHistory();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tuev-faq"] && !Shopify.designMode) return;
  try {
    
  /* Toggle aria-expanded on FAQ details open/close */
  document.querySelectorAll('.tuev__faq-item').forEach(function(item) {
    item.addEventListener('toggle', function() {
      var summary = item.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
